import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { AvatarModule } from '../avatar/avatar.module';

import { MergeUsersModalComponent } from './merge-users-modal.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, AvatarModule],
  declarations: [MergeUsersModalComponent],
  exports: [MergeUsersModalComponent],
})
export class MergeUsersModalModule {}
